<template>
    <div class="lang arabic">
        <div class="info">
            <div class="table">
                <table>
                    <caption>RESULTS (Visit consultation, Postal consultation, View internet result)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row">للحصول على زيارة الاستشارة</th>
                            <td class="left">
                                مكنك زيارة مركز تعزيز الصحة في الوقت والتاريخ المقرر لاستشارة الطبيب
                                <br>
                                سيتم إحالتك إلى القسم المتعلق بأي نتائج تم التوصل إليها في الاستشارة.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">في الاستشارة البريدية</th>
                            <td class="left">
                                ستصل النتائج في غضون 3 أيام عمل عبر البريد المسجل 
                                <br>
                                قبل إرسال النتيجة سوف تتلقى مكالمة من إحدى ممرضاتنا وسيتم توجيهك إلى موعد للمرضى الخارجيين إذا اعتبر ذلك ضروريًا استنادًا إلى النتائج.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">إذا اخترت عرض نتائجك على الإنترنت</th>
                            <td class="left">
                                فقد تجد النتائج ضمن [عرض النتيجة] على صفحتك على موقع الويب الخاص بمركز العافية لتعزيز الصحة، مستشفى سيول التابعة لجامعة إيهوا النسائية بعد التسجيل بدءًا من تاريخ بدء الاستشارة.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="botton-wrap"><a href="" class="main-button c-main">عرض النتائج</a></div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>